import { Link } from 'react-router'
import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { ArrowRight } from 'lucide-react'
import { pageUrl } from '../seo'

// Os rótulos vêm de navbar.links.*: são os mesmos da navegação e assim não
// divergem entre si na tradução.
const cards = [
    { key: 'trafico', href: '/trafico-de-seres-humanos-e-exploracao' },
    { key: 'oQueFazer', href: '/o-que-fazer' },
    { key: 'informacoesUteis', href: '/informacoes-uteis' },
    { key: 'direitos', href: '/direitos' },
    { key: 'apoio', href: '/apoio', accent: true },
]

export default function Home() {
    const { t } = useTranslation()
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <title>{t('home.metaTitle')}</title>
            <meta name="description" content={t('home.metaDescription')} />
            {/* pageUrl() já inclui a base da língua (/, /en/, /uk/, …) */}
            <link rel="canonical" href={pageUrl()} />
            <meta property="og:url" content={pageUrl()} />
            {/* Hero */}
            <section className="relative overflow-hidden" style={{ backgroundColor: '#00203F' }}>
                {/* Full background image */}
                <div
                    className="absolute inset-0"
                    style={{
                        backgroundImage: 'url(/assets/images/TSH-scaled.png)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                    }}
                />
                {/* Dark overlay for text readability */}
                <div
                    className="absolute inset-0"
                    style={{ backgroundColor: 'rgba(0,32,63,0.65)' }}
                />
                <div className="max-w-7xl mx-auto px-8 lg:px-16 py-24 lg:py-36 relative z-10">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.1 }}
                        className="max-w-4xl"
                    >
                        <h1
                            className="font-heading text-4xl lg:text-6xl font-extrabold tracking-tight leading-tight mb-8 text-mint"
                        >
                            {t('home.heroTitle')}
                        </h1>
                        <div className="space-y-4 text-lg leading-relaxed" style={{ color: 'rgba(255,255,255,0.85)' }}>
                            <p>{t('home.heroP1')}</p>
                            <p>{t('home.heroP2')}</p>
                        </div>
                    </motion.div>
                </div>
            </section>

            {/* Navigation Cards */}
            <section className="bg-white">
                <div className="max-w-7xl mx-auto px-8 lg:px-16 py-16 lg:py-24">
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                        {cards.map((card, i) => (
                            <motion.div
                                key={card.href}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4, delay: 0.1 * i }}
                                className={i === 0 ? 'sm:col-span-2 lg:col-span-2' : ''}
                            >
                                <Link
                                    to={card.href}
                                    className={`group flex items-center justify-between p-6 rounded-2xl border font-nav font-bold text-lg transition-all duration-300 h-full ${
                                        card.accent
                                            ? 'bg-navy text-mint border-navy hover:bg-navy-dark focus-visible:ring-2 focus-visible:ring-mint focus-visible:ring-offset-2'
                                            : 'bg-white text-navy border-slate-200 hover:border-mint hover:shadow-[0_10px_25px_rgba(0,32,63,0.08)] hover:-translate-y-[3px] focus-visible:border-mint focus-visible:shadow-[0_10px_25px_rgba(0,32,63,0.08)] focus-visible:ring-2 focus-visible:ring-navy/30'
                                    }`}
                                >
                                    <span>{t(`navbar.links.${card.key}`)}</span>
                                    <ArrowRight
                                        size={20}
                                        className={`shrink-0 ml-3 transition-transform group-hover:translate-x-1 group-focus-visible:translate-x-1 ${card.accent ? 'text-mint' : 'text-navy'}`}
                                    />
                                </Link>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>
        </motion.div>
    )
}
